export enum FormField {
  name = 'name',
  key = 'key',
  owner_id = 'owner_id',
  permission_id = 'permission_id',
  project_ids = 'project_ids',
}
